import PropTypes from "prop-types";
import { Box, FormControlLabel, Radio } from "@material-ui/core";

export default function TipoColetaCard({
  selected,
  title,
  subtitle,
  onSelect,
  disabled,
  classes,
}) {
  const rootClass = [
    classes.tipoCard,
    selected ? classes.tipoCardSelected : "",
    disabled ? classes.tipoCardDisabled : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div
      role="button"
      tabIndex={disabled ? -1 : 0}
      className={rootClass}
      onClick={() => !disabled && onSelect()}
      onKeyDown={(e) => {
        if (disabled) return;
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onSelect();
        }
      }}
    >
      <FormControlLabel
        className={classes.radioLabel}
        style={{ margin: 0, alignItems: "flex-start", width: "100%" }}
        control={
          <Radio
            color="primary"
            checked={selected}
            disabled={disabled}
            onChange={() => !disabled && onSelect()}
            disableRipple
          />
        }
        label={
          <Box>
            <div className={classes.tipoCardTitle}>{title}</div>
            <div className={classes.tipoCardSub}>{subtitle}</div>
          </Box>
        }
      />
    </div>
  );
}

TipoColetaCard.propTypes = {
  selected: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  classes: PropTypes.object.isRequired,
};

TipoColetaCard.defaultProps = {
  disabled: false,
};
